import React, { useRef, useState } from "react";
import "./style.scss";
import { Link, useLocation } from "react-router-dom";
import facebook from "../../asset/images/facebook_compressed.webp";
import instagram from "../../asset/images/instagram_compressed.webp";
import youtube from "../../asset/images/youtube_compressed.webp";
import Playbtn from "../../asset/images/ggl play_compressed.webp";
import Storebutton from "../../asset/images/store_compressed.webp";
import logo from "../../asset/logo/logo3.webp";
import homelogo from "../../asset/images/home1_compressed.webp";
import homelogo2 from "../../asset/images/home_compressed.webp";
import eventlogo from "../../asset/images/Shape 5_compressed.webp";
import eventlogo2 from "../../asset/images/Shape 5 (1)_compressed.webp";
import topplayerlogo from "../../asset/images/Shape 4_compressed.webp";
import topplayerlogo2 from "../../asset/images/Shape 4 (1)_compressed.webp";
import tipsandtrickslogo from "../../asset/TipsandTricks/tips tricks inactive.webp";
import tipsandtrickslogo2 from "../../asset/TipsandTricks/tips tricks active.webp";
import updatelogo from "../../asset/images/Shape 2844_compressed.webp";
import updatelogo2 from "../../asset/images/Shape 2844 (1)_compressed.webp";
import circleQuestion from "../../asset/images/Shape 7_compressed.webp";
import circleQuestion2 from "../../asset/images/Shape 7 (1)_compressed.webp";
import mobmenu from "../../asset/images/menu_compressed.webp";
import crossmenu from "../../asset/images/cancel_compressed.webp"
import notify from "../../shared/notify";
import { trackEvent } from "../../shared/analytics";


const Header = () => {
  const FacebookUrl = " https://www.facebook.com/ludosuprstar";
  const YoutubeUrl = "https://www.youtube.com/@BlackLightSW";
  const InstagramUrl = "https://www.instagram.com/ludo.superstar/";
  const storeUrl = "https://apps.apple.com/in/app/ludo-superstar/id1314264574";
  const playbtnUrl = "https://play.google.com/store/apps/details?id=com.blacklightsw.ludo";
  const location = useLocation();
  // Extract the active route from pathname
  // With basename, location.pathname should be relative like "/home", "/event"
  // But to be safe, we'll handle both cases
  const pathname = location.pathname;
  
  // Remove leading/trailing slashes and split
  const cleanPath = pathname.replace(/^\/+|\/+$/g, "");
  const segments = cleanPath.split("/").filter(seg => seg && seg !== "bsw-game");
  
  // Get the first meaningful segment (the route name)
  const url = segments[0] || "ludo-superstar-home";
  const [email, setEmail] = useState();
  const [show, setShow] = useState(false);
  const [subscribeBtn, setSubscribeBtn] = useState(false);
  const servicePromiseRef = useRef(null);

  const getService = async () => {
    if (!servicePromiseRef.current) {
      servicePromiseRef.current = import("../../shared/service/service").then((mod) => mod.default);
    }
    return servicePromiseRef.current;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleClick = () => {
    setSubscribeBtn(!subscribeBtn)
  };

  const handleSubscribebtn = async () => {
    if (!isValidEmail(email)) {
      trackEvent("subscribe_error", { reason: "invalid_email", location: "header" });
      notify("Please enter a valid email address", "danger");
      return;
    }

    let paylaod = { email: email };
    trackEvent("subscribe_attempt", { location: "header" });

    try {
      const Service = await getService();
      const response = await Service.post1("subscribe", paylaod, (result) => result);
      if (response?.data?.status === "success") {
        trackEvent("subscribe_success", { location: "header" });
        notify(response?.data?.message || "Subscribed successfully.", "success");
        return;
      }
      trackEvent("subscribe_error", { reason: "api_error", location: "header" });
      notify(response?.data?.message || "Subscription failed.", "danger");
    } catch (error) {
      trackEvent("subscribe_error", { reason: "api_error", location: "header" });
      notify(error?.response?.data?.message || "Subscription failed.", "danger");
    }
  };
  const handleErr = () => {
    trackEvent("subscribe_error", { reason: "terms_not_accepted", location: "header" });
    notify("Please accept the term and condition", "danger");
  };

  const MenuHide = () => {
    setShow(!show)
  };



  return (
    <>
      <div className="Sidebar-View">
        <div className="BodySection">
          <div className="wrapper">
            <nav id="sidebar" className="sidebar-container">
              <img className="main-logo" src={logo} alt="" loading="eager" fetchPriority="high" width="185" height="144" />
              <Link className="decoration-none" to={`/ludo-superstar-home`} style={{ pointerEvents: 'none' }} >
                <div className="home-box">
                  <button className={`nav-link ${url === "ludo-superstar-home" ? "active1" : ""}`} type="button" style={{ pointerEvents: 'auto' }} >
                    {url === "ludo-superstar-home" ? <img alt="" src={homelogo2} className="homeicon-event" loading="lazy" /> : <img alt="" src={homelogo} className="homeicon-event" loading="lazy" />}
                    Home
                  </button>
                </div>
              </Link>

              <Link className="decoration-none" to={`/ludo-events`} style={{ pointerEvents: 'none' }}>
                <div className="home-box">
                  <button className={`nav-link ${url === "ludo-events" ? "active1" : ""}`} type="button" style={{ pointerEvents: 'auto' }} >
                    {url === "ludo-events" ? <img alt="" src={eventlogo2} className="home-icon-event" loading="lazy" /> : <img alt="" src={eventlogo} className="home-icon-event" loading="lazy" />}
                    Event
                  </button>
                </div>
              </Link>

              <Link className="decoration-none" to={`/top-ludo-players`} style={{ pointerEvents: 'none' }}>
                <div className="home-box">
                  <button className={`nav-link ${url === "top-ludo-players" ? "active1" : ""}`} type="button" style={{ pointerEvents: 'auto' }}>
                    {url === "top-ludo-players" ? <img alt="" src={topplayerlogo2} className="home-icon" loading="lazy" /> : <img alt="" src={topplayerlogo} className="home-icon" loading="lazy" />}
                    Top Players
                  </button>
                </div>
              </Link>

              <Link className="decoration-none" to={`/ludo-tips-and-tricks`} style={{ pointerEvents: 'none' }}>
                <div className="home-box">
                  <button className={`nav-link ${url === "ludo-tips-and-tricks" ? "active1" : ""}`} type="button" style={{ pointerEvents: 'auto' }}>
                    {url === "ludo-tips-and-tricks" ? <img alt="" src={tipsandtrickslogo2} className="home-icon" loading="lazy" /> : <img alt="" src={tipsandtrickslogo} className="home-icon" loading="lazy" />}
                    Tips & Tricks
                  </button>
                </div>
              </Link>

              <Link className="decoration-none" to={`/ludo-updates`} style={{ pointerEvents: 'none' }}>
                <div className="home-box">
                  <button className={`nav-link ${url === "ludo-updates" ? "active1" : ""}`} type="button" style={{ pointerEvents: 'auto' }}>
                    {url === "ludo-updates" ? <img alt="" src={updatelogo2} className="home-icon" loading="lazy" /> : <img alt="" src={updatelogo} className="home-icon" loading="lazy" />}
                    Updates
                  </button>
                </div>
              </Link>

              <Link className="decoration-none" to="/ludo-help-center" style={{ pointerEvents: 'none' }}>
                <div className="home-box">
                  <button className={`nav-link ${url === "ludo-help-center" ? "active1" : ""}`} type="button" style={{ pointerEvents: 'auto' }} onClick={() => trackEvent("click_help_center", { location: "header" })}>
                    {url === "ludo-help-center" ? <img alt="" src={circleQuestion2} className="help-icon" loading="lazy" /> : <img alt="" src={circleQuestion} className="help-icon" loading="lazy" />}
                    Help Center
                  </button>
                </div>
              </Link>


              <div className="d-flex justify-content-around socialmedia-box">
                <a href={FacebookUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon" onClick={() => trackEvent("click_social", { platform: "facebook" })}> <img alt="" src={facebook} className="img-box" draggable={false} loading="lazy" /> </a>
                <a href={YoutubeUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon" onClick={() => trackEvent("click_social", { platform: "youtube" })}><img alt="" src={youtube} className="img-box" draggable={false} loading="lazy" /></a>
                <a href={InstagramUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon" onClick={() => trackEvent("click_social", { platform: "instagram" })}><img alt="" src={instagram} className="img-box" draggable={false} loading="lazy" /></a>
              </div>

            </nav>
            <div className="playbtn-box">
              <a href={playbtnUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon m-2" style={{ pointerEvents: 'none' }}>
                <img src={Playbtn} className="playbutton" alt="" style={{ pointerEvents: 'auto' }} onClick={() => trackEvent("click_play_store", { location: "header_sidebar" })} loading="lazy" />
              </a>
              <a href={storeUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon m-2" style={{ pointerEvents: 'none' }}>
                <img src={Storebutton} className="playbutton" alt="" style={{ pointerEvents: 'auto' }} onClick={() => trackEvent("click_app_store", { location: "header_sidebar" })} loading="lazy" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-view">
        <div className="mobheader">
          <div className="mob-inner-header">
            <div className="mnav-bar">
              <img alt="" className="mob-logo" src={logo} loading="eager" fetchPriority="high" width="80" height="62" />
            </div>
            <div className="mlogo" onClick={MenuHide}>
              {show ? <img alt="" className="cross-menu" src={crossmenu} loading="eager" width="23" height="23" /> : <img alt="" className="mob-menu" src={mobmenu} loading="eager" width="28" height="28" />}
            </div>
          </div>
        </div>
        <nav className="menu--left" role="navigation">
          <div className={show ? "menuItem show-menu" : "menuItem"} >
            <div className="wrapper">
              <nav id="sidebar" className="sidebar-container">
                <img alt="" className="main-logo" src={logo} loading="eager" fetchPriority="high" width="185" height="144" />
                <Link className="decoration-none" to={`/ludo-superstar-home`} >
                  <div className="home-box">
                    <button onClick={MenuHide} className={`nav-link ${url === "ludo-superstar-home" ? "active1" : ""}`} type="button">
                      {url === "ludo-superstar-home" ? <img alt="" src={homelogo2} className="homeicon-event" loading="lazy" /> : <img alt="" src={homelogo} className="homeicon-event" loading="lazy" />}
                      Home
                    </button>
                  </div>
                </Link>

                <Link className="decoration-none" to={`/ludo-events`} >
                  <div className="home-box">
                    <button onClick={MenuHide} className={`nav-link ${url === "ludo-events" ? "active1" : ""}`} type="button">
                      {url === "ludo-events" ? <img alt="" src={eventlogo2} className="home-icon-event" loading="lazy" /> : <img alt="" src={eventlogo} className="home-icon-event" loading="lazy" />}
                      Event
                    </button>
                  </div>
                </Link>

                <Link className="decoration-none" to={`/top-ludo-players`}>
                  <div className="home-box">
                    <button onClick={MenuHide} className={`nav-link ${url === "top-ludo-players" ? "active1" : ""}`} type="button">
                      {url === "top-ludo-players" ? <img alt="" src={topplayerlogo2} className="home-icon" loading="lazy" /> : <img alt="" src={topplayerlogo} className="home-icon" loading="lazy" />}
                      Top Players
                    </button>
                  </div>
                </Link>

                <Link className="decoration-none" to={`/ludo-tips-and-tricks`}>
                  <div className="home-box">
                    <button onClick={MenuHide} className={`nav-link ${url === "ludo-tips-and-tricks" ? "active1" : ""}`} type="button">
                      {url === "ludo-tips-and-tricks" ? <img alt="" src={tipsandtrickslogo2} className="home-icon" loading="lazy" /> : <img alt="" src={tipsandtrickslogo} className="home-icon" loading="lazy" />}
                      Tips & Tricks
                    </button>
                  </div>
                </Link>

                <Link className="decoration-none" to={`/ludo-updates`}>
                  <div className="home-box">
                    <button onClick={MenuHide} className={`nav-link ${url === "ludo-updates" ? "active1" : ""}`} type="button" >
                      {url === "ludo-updates" ? <img alt="" src={updatelogo2} className="home-icon" loading="lazy" /> : <img alt="" src={updatelogo} className="home-icon" loading="lazy" />}
                      Updates
                    </button>
                  </div>
                </Link>

                <Link className="decoration-none" to="/ludo-help-center">
                  <div className="home-box">
                    <button onClick={() => { trackEvent("click_help_center", { location: "header_mobile" }); MenuHide(); }} className={`nav-link ${url === "ludo-help-center" ? "active1" : ""}`} type="button">
                      {url === "ludo-help-center" ? <img alt="" src={circleQuestion2} className="help-icon" loading="lazy" /> : <img alt="" src={circleQuestion} className="help-icon" loading="lazy" />}
                      Help Center
                    </button>
                  </div>
                </Link>
                <div className="d-flex justify-content-around socialmedia-box">
                  <a href={FacebookUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon"><img alt="" src={facebook} className="img-box" draggable={false} loading="lazy" /> </a>
                  <a href={YoutubeUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon"> <img src={youtube} className="img-box" alt="" draggable={false} loading="lazy" /> </a>
                  <a href={InstagramUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon"><img src={instagram} className="img-box" alt="" draggable={false} loading="lazy" /></a>
                </div>
                <div className="playbtn-box" >
                  <a href={playbtnUrl} target="_blank" rel="noopener noreferrer" style={{ pointerEvents: 'none' }}>
                    <img src={Playbtn} className="playbutton" alt="" style={{ pointerEvents: 'auto' }} onClick={() => trackEvent("click_play_store", { location: "header" })} loading="lazy" />
                  </a>

                  <a href={storeUrl} target="_blank" rel="noopener noreferrer" style={{ pointerEvents: 'none' }}>
                    <img src={Storebutton} className="playbutton" alt="" style={{ pointerEvents: 'auto' }} onClick={() => trackEvent("click_app_store", { location: "header" })} loading="lazy" />
                  </a>
                </div>
              </nav>
            </div>

            <div className="wrapper">
              <nav id="sidebar" className="sidebar-container">
                <div className="text-box">
                  <h6 className="mail-list">JOIN OUR MAILING LIST!</h6>
                  <p className="para-text"> Signup for special updates on event, deals and more! </p>
                </div>

                <div className="email-box">
                  <label className="input-box">Email<span className="required-field">:</span></label>
                  <input
                    className="form-control-box"
                    type="email"
                    placeholder="Enter Email Address"
                    autoComplete="off"
                    required=""
                    maxLength="100"
                    minLength="10"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>

                <div className="check-box">
                  <input type="checkbox" className={subscribeBtn ? "checkk active" : "checkk"} onClick={handleClick} />
                  <span className="checkbox-text">
                    I want to receive emails , including game updates and
                    offers , from BlackLight and its affiliates. I can opt out
                    at any time. By subscribing , I agree to BlackLight's <Link to="/terms-of-service" className="term-link" onClick={() => trackEvent("click_external_link", { link: "terms_of_service" })}>Term of Service</Link> and
                    <Link to="/privacy-policy" className="term-link" onClick={() => trackEvent("click_external_link", { link: "privacy_policy" })}> Privacy policy</Link>.
                  </span>
                </div>
                {subscribeBtn ?
                  <button onClick={handleSubscribebtn} className={subscribeBtn ? "subscribe-button active" : "subscribe-button"}>SUBSCRIBE</button>
                  : <button onClick={handleErr} className={subscribeBtn ? "subscribe-button active" : "subscribe-button"}>SUBSCRIBE</button>
                }

                <div className="term-policy">
                <span className="term-policy-row">
                  <Link to="/terms-of-service" className="term-condition" onClick={() => trackEvent("click_external_link", { link: "terms_of_service" })}>• Terms of Service</Link>
                  {" "}
                  <Link to="/privacy-policy" className="term-condition" onClick={() => trackEvent("click_external_link", { link: "privacy_policy" })}>• Privacy Policy</Link>
                </span>
                  <span className="term-policy-row">
                    <Link to="/about-ludo-superstar" className="term-condition">• About</Link>
                    {" "}
                    <Link to="/contact-ludo-superstar" className="term-condition">• Contact</Link>
                    {" "}
                    <Link to="/blacklight-studio-games" className="term-condition">• Company</Link>
                  </span>
                  <h1 className="copyright-text">Copyright © Blacklight Studio Works</h1>
                </div>
              </nav>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};
export default Header;